import React from 'react';
import { Checkbox, CheckboxProps, Flex } from '@fluentui/react-northstar';
import MgtCss from '../../../mgt.module.css';
import { FieldErrorText, RequiredAsterisk } from '../FieldErrorText';

interface Props {
  label: string;
  checked: boolean;
  onChange: (
    checked: Omit<CheckboxProps, 'checked'> & {
      checked: boolean;
    }
  ) => void;
  children?: any;
  /** Under the field: what is wrong with it, in the ticket page's red. */
  error?: React.ReactNode;
}

/** A Bulk Edit field: ticked, it is set on every selected ticket and needs a value - so it is marked required. */
export const LabelWithCheckbox = ({
  label,
  checked,
  onChange,
  children,
  error
}: Props) => {
  return (
    <div className="mb-2.5">
      <Flex vAlign="center">
        <Checkbox
          id={label + '_fieldCheckbox'}
          label={label}
          defaultChecked={checked}
          checked={checked}
          onChange={(_e, isChecked) => {
            onChange(isChecked);
          }}
          className={`${MgtCss.fieldCheckbox} px-0 py-0.5`}
        />
        {checked && <RequiredAsterisk />}
      </Flex>
      {children}
      {error && <FieldErrorText>{error}</FieldErrorText>}
    </div>
  );
};
